import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import s from './TimeSlot.css';


// Uhhh, we're here for the slots. https://www.youtube.com/watch?v=MdQC-DD9fz4
// Only 1 TimeSlot can be selected at a time.
export default class TimeSlot extends Component {
  static propTypes = {
    date: PropTypes.string,
    slots: PropTypes.array,
    handleTimeSlotSelection: PropTypes.func,
  };

  // Handles passing the selected time and day back up the parent chain
  handleChange = (e) => {
    const parsed = JSON.parse(e.target.value);


    // Pass back the entire slot selected
    this.props.handleTimeSlotSelection(parsed);
  };

/*
@TODO:
  We can technically apply a different className based on how many dates are returned
  we could leverage that to apply css differently. We would have to pass the dates.length
  value down from DateRange e.g.: (dates <= 5 ? s.ruleForFiveorLess : s.defaultRule).
  The biz may want this in case they don't like how the calendar is styled.
*/
  render() {
    const formattedDate = moment(this.props.date).format('dddd, MMMM Do');
    const timeSlots = this.props.slots.map((timeSlot, idx) => {

      /*
        Convert a start time represented as minutes into a user friendly display date/time
        and generate a unique element ID from this time stamp
       */
      const slotStartTime = timeSlot.start;
      const slotTimeHours = slotStartTime / 60;
      const slotTimeMinutes = slotStartTime % 60;
      const slotDateTime = moment(this.props.date).hour(slotTimeHours).minutes(slotTimeMinutes);
      const displayTime = slotDateTime.format('h:mm A');
      const elementId = slotDateTime.unix();

      /*
        Construct an object that will hold all time slot properties, as well as, the particular
        date that was selected by the user.

        NOTE: HTML `value` attribute converts objects to strings if the value assigned is an object.
        Therefore, correctly stringify our object as JSON prior to assignment so that it can
        be correctly processed later by the handleChange event.
      */
      const selectedSlot = JSON.stringify({
        date: this.props.date,
        slot: timeSlot,
      });

      const inputId = `selectedSlot__${elementId}`;

      return (
        <div
          id={`selectedTimeSlot__${elementId}`}
          key={idx}
          className={s.toggleBtnGrp}
        >
          <div className={s.wrapper}>
            <input
              type="radio"
              id={inputId}
              name="selectedSlot"
              value={selectedSlot}
              onChange={this.handleChange}
              className={s.radio}
              aria-label={`Select time slot at ${displayTime}`}
            />
            <label
              htmlFor={inputId}
              className={s.toggleBtn}
            >
              {displayTime}
            </label>
          </div>
        </div>
      );
    });

    return (
      <fieldset className={s.component}>
        <legend className={s.visuallyHidden}>Available time slots for {formattedDate}</legend>
        {timeSlots}
      </fieldset>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Pages/Appointments/Scheduling/Calendar/TimeSlot.js